import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';

export interface Args {
	icon?: IconName;
	onClose?: () => void;
}

interface CommonPopupDrawerComponentInterface<T> {
	Args: T;
	Blocks: {
		header?: [];
		content: [];
	};
}

export default class CommonPopupDrawerComponent extends Component<
	CommonPopupDrawerComponentInterface<Args>
> {
	get icon() {
		return this.args.icon || '';
	}

	@action
	close() {
		if (this.args.onClose) {
			this.args.onClose();
		}
	}
	<template>
		{{#if (has-block "header")}}
			<div class="title">
				{{#if this.icon}}
					<CommonUiIconComponent @name={{this.icon}} @size="lg" />
				{{/if}}

				{{yield to="header"}}
			</div>

			<a role="button" class="close" {{on "click" this.close}}>
				<CommonUiIconComponent @name="Close" @size="lg" />
			</a>
		{{/if}}

		<div class="content {{unless (has-block 'header') 'content--no-header'}}">
			{{yield to="content"}}
		</div>
	</template>
}
